"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var kit_exports = {};
__export(kit_exports, {
  extensionKit: () => extensionKit,
  mergeKitOptions: () => mergeKitOptions
});
module.exports = __toCommonJS(kit_exports);
var import_core = require("@tiptap/core");
function extensionKit(name, fn) {
  return import_core.Extension.create({
    name,
    addExtensions() {
      const e = /* @__PURE__ */ __name((extension, options) => {
        return { extension, options: options ?? true };
      }, "e");
      const extensions = [];
      const entries = fn(e, this.options);
      for (const [key, _data] of Object.entries(entries)) {
        const data = _data;
        if (data?.extension === void 0) continue;
        let options = mergeKitOptions(data.options, this.options[key]) ?? false;
        if (options === false) continue;
        if (options === true) {
          if (typeof data.options === "object") {
            options = data.options;
          } else {
            options = {};
          }
        }
        extensions.push(data.extension.configure(options));
      }
      return extensions;
    }
  });
}
__name(extensionKit, "extensionKit");
function mergeKitOptions(target, source) {
  if (typeof target === "object" && typeof source === "object") {
    const output = { ...target };
    Object.keys(source).forEach((key) => {
      const a = target[key];
      const b = source[key];
      if (typeof a === "object" && typeof b === "object") {
        output[key] = mergeKitOptions(a, b);
      } else {
        output[key] = b ?? a;
      }
    });
    return output;
  }
  return source ?? target;
}
__name(mergeKitOptions, "mergeKitOptions");
//# sourceMappingURL=kit.js.map
